import { HandlingUnitType } from "@redotech/redo-model/freight/freight";
import { FreightHandlingUnitRowSchema } from "@redotech/redo-model/freight/freight-handling-unit";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const createFreightHandlingUnit = {
  name: "createFreightHandlingUnit" as const,
  input: z.object({
    name: z.string(),
    type: createEnum(HandlingUnitType, { enumName: "HandlingUnitType" }),
    length: z.number(),
    width: z.number(),
    height: z.number(),
    isDefault: z.boolean().optional(),
  }),
  output: FreightHandlingUnitRowSchema,
};
